import React from 'react'

const JoinRoomIcon = () => {
    return (
        <svg className="join-room-icon" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144.96 134.45">
            <path d="M59.26,25.22l13.47,15.69,21.42,22.71c1.9,2.02,1.9,5.18,0,7.2l-21.42,22.71-13.47,15.69c-3.67,4.26-10.66,1.63-10.6-3.99l10.05-11.7,19.88-21.09H5.09c-2.81,0-5.09-2.28-5.09-5.08,0-1.41.57-2.68,1.49-3.6.92-.93,2.2-1.49,3.6-1.49h73.76l-20.14-21.36-10.05-11.7c-.06-5.63,6.94-8.26,10.6-3.99Z" />
            <path d="M130.5,0H24.96c-7.98,0-14.46,6.47-14.46,14.45v19.83h13.42v-15.8c0-2.8,2.27-5.07,5.07-5.07h97.49c2.8,0,5.07,2.27,5.07,5.07v97.49c0,2.8-2.27,5.07-5.07,5.07H28.99c-2.8,0-5.07-2.27-5.07-5.07v-8.35h-13.42v12.38c0,7.98,6.48,14.45,14.46,14.45h105.54c7.99,0,14.46-6.47,14.46-14.45V14.45c0-7.98-6.47-14.45-14.46-14.45Z" />
        </svg>
    )
}

export default JoinRoomIcon
